var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgForwardArrows(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 33,
    viewBox: "0 0 56 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.7188 15.6325C32.389 16.0167 32.389 16.9833 31.7188 17.3675L9.80538 29.9309C9.13872 30.3132 8.308 29.8319 8.308 29.0634L8.308 3.93659C8.308 3.16814 9.13872 2.68684 9.80538 3.06905L31.7188 15.6325Z",
    fill: "#FAB55A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7346 15.6325C54.4047 16.0167 54.4047 16.9833 53.7346 17.3675L31.8211 29.9309C31.1545 30.3132 30.3238 29.8319 30.3238 29.0634L30.3238 3.93659C30.3238 3.16814 31.1545 2.68684 31.8211 3.06905L53.7346 15.6325Z",
    fill: "#FAB55A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForwardArrows);
export default __webpack_public_path__ + "static/media/Forward_Arrows.7b96c6a9e125b395cd48dc5ecb37ad71.svg";
export { ForwardRef as ReactComponent };